<template>
  <div class="main-body">
    <div class="header">小度智能屏</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">绑定设备</el-button>

        <div style="float:right">

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 10px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-input size="mini" placeholder="请输入设备号" v-model="imei" clearable style="margin-right:10px;width:140px"></el-input>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border>

        <el-table-column prop="userName" label="用户名" width="100"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="120" :formatter="getPhoneStr"></el-table-column>
        <el-table-column prop="imei" label="设备号" width="200"></el-table-column>

        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="350">
          <template slot-scope="scope">
            <el-button type="success" size="mini"  @click="willCall(scope.row,0)" >视频呼叫</el-button>
            <el-button type="success" size="mini"  @click="willCall(scope.row,1)" >语音呼叫</el-button>
            <el-button type="success" size="mini"  @click="openCallRecord(scope.row)" >呼叫记录</el-button>
            <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change"
          ></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false"  v-on:getList="getList"></Add>
    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>
    <CallRecord ref="myCallRecord" v-show="showModalCallRecord" v-on:closeAdd="showModalCallRecord=false"  v-on:getList="getList"></CallRecord>




    <!-- 来电弹窗 -->
    <div role="dialog" class="modal2 fade" id="incoming-call-dialog" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="usr-info">
              <img class="usr-pho" src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-7/1658388218664/pho.png">
              <!--用于来电展示，接入方通过来电sn查询获取来电姓名 -->
              <p class="usr-name">未知来电</p>
              <p class="incoming-call-tip">邀请您通话</p>
            </div>
            <div class="op-btns">
              <div class="incoming-call-reject">
                <img
                    onclick="rejectCall()"
                    src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
                >
                <p class="op-txt">挂断</p>
              </div>
              <div class="incoming-call-video">
                <img
                    onclick="answerCall(0)"
                    src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433226356/videoCall.png"
                >
                <p class="op-txt">视频通话</p>
              </div>
              <div class="incoming-call-audio">
                <img
                    onclick="answerCall(1)"
                    src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433255465/audioCall.png"
                >
                <p class="op-txt">语音通话</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 去电响铃 -->
    <div id="outing-call-view" style="display: none;">
      <div class="peer-info">
        <img class="peer-pho" src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-7/1658388218664/pho.png">
        <!-- 业务方根据实际呼叫用户进行替换 -->
        <p class="peer-name">被叫名字</p>
        <p class="outing-call-tip">设备正在响铃中，请不要挂断...</p>
      </div>
      <div class="op-btns">
        <div class="out-call-mode">
          <img
              onclick="changeMode()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png"
          >
          <p class="out-call-mode-txt">视频呼叫</p>
        </div>
        <!-- <div class="out-call-mode">
            <img
                onclick="changeMode()"
                src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png"
            >
            <p>语音呼叫</p>
        </div> -->
        <div>
          <img
              onclick="dropCall()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
          >
          <p style="color: #E24940">挂断</p>
        </div>
      </div>
    </div>

    <!-- 通话界面 -->
    <div id="call-view" style="display: none;">
      <div class="peer-view main-view">
        <video id='video-peer' autoPlay></video>
        <audio id='audio-peer' autoPlay></audio>
        <div class="audio-tip-wrap">
          <!-- <p class="audio-name online-ellipsis">对端姓名</p> -->
          <p class="audio-call">语音通话中</p>
        </div>
      </div>
      <div class="local-view sub-view">
        <video id='video-local' autoPlay></video>
        <audio id='audio-local' autoPlay></audio>
        <div class="audio-tip-wrap">
          <p class="audio-name online-ellipsis">本机</p>
          <p class="audio-call">语音通话中</p>
        </div>
      </div>
      <div class="op-btns">
        <div class="mute-change-btn">
          <img
              onclick="changeMute()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png"
          >
          <p class="a-mute">静音</p>
        </div>
        <!-- <div>
            <img
                onclick="changeAudioMute"
                src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png"
            >
            <p class="a-mute">已静音</p>
        </div> -->
        <div class="mode-change-btn">
          <img
              onclick="changeMode()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png"
          >
          <p class="v-mode">视频通话</p>
        </div>
        <!-- <div>
            <img
                onclick="changeMode"
                src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png"
            >
            <p>语音通话</p>
        </div> -->
        <div>
          <img
              onclick="dropCall()"
              src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661433175110/reject.png"
          >
          <p style="color: #E24940">挂断</p>
        </div>
      </div>
    </div>
    <audio id="ring-music" loop>
      <source src="https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-9/1662024495462/ring_new.mp3" type="audio/mpeg">
    </audio>
    <div class="alert alert-warning fade in" id="message-alert">
      <a href="#" class="close" data-dismiss="alert">
        &times;
      </a>
      <span class="call-message">呼叫超时，请稍后再试</span>
    </div>



  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getGovernmentCode} from "@/utils/auth";

import Add from "./Add"
import Elderly from "@/views/Elderly/Comm/ElderlyGov";
import CallRecord from "./CallRecord";

export default {
  name: "Role",
  data() {
    return {


      showModalAdd:false,
      tableLoading:false,
      sBJDataShow:false,
      showModalCallRecord:false,

      showModalGetElderly:false,
      showModalBigView:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      userCode: "",
      userName:'',
      imei: "",

      duerRtcSdk:null,
      duerRtc:null,
      callInfo : {},

    };
  },
  components: {Add,Elderly,CallRecord},
  created() {
    this.init();

    this.getList();
    this.th = this.$store.state.tableHeight;

    window.changeMute = this.changeMute;
    window.changeMode = this.changeMode;
    window.dropCall = this.dropCall;
    window.rejectCall = this.rejectCall;
    window.answerCall = this.answerCall;

  },

  destroyed() {
    if(this.duerRtc != null){
      this.duerRtc.logout();
    }

  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    init(){

      //this.getToken();

    },

    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },

    openCallRecord(row){
      this.$refs.myCallRecord.init(row);
      this.showModalCallRecord = !this.showModalCallRecord;
    },


    getToken(){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceXDu/getUidToken2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode:getGovernmentCode(),
        },
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          let uid = response.data.data.uid;
          let rtc_appid = response.data.data.rtc_appid;
          let token = response.data.data.token;

          this.initSocket(uid,rtc_appid,token);

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });

    },

    initSocket(uid,appId,token){

      let enbaleRtcDebugLog = true;

      let appName = "appName";
      //let uid = "uid40001730";
      //let appId = "fw05ci27";
      //let token = "12002-fw05ci27ZSJcaGUo8-hMI-rmAAt1aWQ0MDAwMTczMAAQfd-sfVd3ihmCevlS-ru_BQ==";

      // sdk挂载的⽅法
      const duerRtcSdk = window.DUER_rtcsdk;

      // 初始化rtc对象
      const duerRtc = new duerRtcSdk.RtcContext ({ onAuthStatusChanged: auth => {
          // 鉴权状态发⽣变化回调，对不同状态auth.code做分别处理
          //5000表示鉴权通过，可在此处进⾏⼊席操作duerRtc.enableCustomer(true);
          // auth.code常⽤值⻅下⾯的常⽤值部分


          console.log(auth);
          if(auth.code == 5000){
            console.log(11111);
            duerRtc.enableCustomer(true);
          }


        },
      }, enbaleRtcDebugLog); // 是否打印⽇志，建议线下调试设置为true，上线设置为false

      // 构造参数建⽴⻓连接参数
      /**
       *uri RTC呼叫系统唯⼀标识定义
       *@param uid 应⽤⽤户唯⼀标识
       *@param appId 应⽤程序唯⼀标识，这⾥是rtc_appid，邮件分配的
       */
      const uri = new duerRtcSdk.CallUri(uid, appId); const loginParams = {
        uri: uri, uid: uid, appId: appId,
        appName: appName, token: token
      };

      // 建⽴⻓连接
      duerRtc.login(loginParams);

      this.duerRtc = duerRtc;
      this.duerRtcSdk = duerRtcSdk;
      this.callInfo = {
        mute: false,
        mode: duerRtcSdk.CallMode.AUDIO_VIDEO
      };

      this.setListener();

    },

    setListener(){

      this.duerRtc.setCallListener({
        onIncomingCall: intent => {
          const serviceInfo = intent.serviceInfo && JSON.parse(intent.serviceInfo) || {};
          intent.serviceInfo = serviceInfo;
          Object.assign(this.callInfo, intent);
          this.incomingViewShow();
          console.log("wwwwwwwwwwwwwww");
          console.log("onIncomingCall", intent);

          console.log(serviceInfo.sn);

        },
        onAddConfereeStateChanged: state => {
          console.log("onAddConfereeStateChanged", state);
        },
        onCallReplaced: replaced => {
          console.log("onCallReplaced", replaced);
        },
        onCallStateChanged: stateInfo => {
          if (stateInfo.state === this.duerRtcSdk.CallState.RINGBACK) {
            // 被叫开始响铃
            this.ringViewShow();
          }
          else if (stateInfo.state === this.duerRtcSdk.CallState.DISCONNECTED) {
            // 通话已经断开
            this.freeCallView();
            if (stateInfo.reason === this.duerRtcSdk.CallReason.TIMEOUT) {
              // 呼叫超时
              this.callTimeout();
            }
          }
          else if (stateInfo.state === this.duerRtcSdk.CallState.CONNECTED) {
            // 通话被正常接听
            this.callViewShow();
          }
          console.log("onCallStateChanged", stateInfo);
        },
        onConfereeLayout: layouts => {
          this.setLayouts(layouts);
          console.log("onConfereeLayout", layouts);
        },
        onRecordStateChanged: recordStateInfo => {
          console.log("onRecordStateChanged", recordStateInfo);
        }
      });

      this.duerRtc.setConnectListener({
        onConnectionChanged: conn => {
          if (conn === 2) {
            // 长链接已建立
            //$('#login-form').hide();
            //$('#device-form').show();
          }
          if (conn === 3) {
            // 长链接已断开
            this.duerRtc = null;
            this.$message.warning("小度连接失败");
          }
          console.log("onConnectionChanged", conn);
        }
      });

      this.duerRtc.setMediaDeviceListener({
        // 麦克风/摄像头状态
        onMediaDeviceStateChanged: (device, state, error) => {
          console.log('onMediaDeviceStateChanged', device, state, error);
        }
      });


    },



    willCall(row,type){
      this.$parent.willCall(row,type);
    },
    willCall2(row,type){

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceXDu/getCallAddressAppIdNumber2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          sn:row.imei,
          isDuerNumber:true,
          governmentCode:getGovernmentCode(),
        },
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          let callAppId = response.data.data.callAppId;//appid
          let callAddress = response.data.data.callAddress;//uid

          this.makeCall(callAppId,callAddress,type);//0：视频，1：语音

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });


    },


    // 呼叫
    makeCall(appId, uid, callMode, callerRole = this.duerRtcSdk.CallerRole.CALL_CENTER) {
      const calleeUri = new this.duerRtcSdk.CallUri(uid, appId);
      let intent = this.duerRtcSdk.MakeCallIntent(calleeUri, this.duerRtcSdk.CallMode.AUDIO_VIDEO);
      callMode && (intent.callMode = callMode);
      callerRole && (intent.callerRole = callerRole);
      this.callInfo.callMode = callMode;
      const result = this.duerRtc.makeCall(intent)
      console.info('makeCall action', intent, result)
      if (this.duerRtcSdk.CallReason.NORMAL == result) {
        // 呼出成功

        setInterval(_ => {
          this.getDevice();
        }, 10000);

      } else if (this.duerRtcSdk.CallReason.ALREADY_IN_CALL == result || this.duerRtcSdk.CallReason.EXCEPTION_INPUT_ILLEGAL == result) {
        console.error('makeCall resaon', this.duerRtcSdk.CallReasonMap.get(result))
      }
      else {
        // 其他原因，目前不会出现
        console.warn('makeCall res', result)
      }
    },
    // 来电接听
    answerCall(mode){
      this.$parent.answerCall(mode);
    },
    answerCall2(mode) {
      this.duerRtc.answerCall(this.callInfo.index, mode, false);
      this.callInfo.callMode = mode;
    },
    // 拒接来电
    rejectCall(){
      this.$parent.rejectCall();
    },
    rejectCall2() {
      this.duerRtc.rejectIncomingCall(this.callInfo.index, 'REJECT_CALL_USER_REASON');
    },
    // 改变通话模式 type 1去电  2通话中
    changeMode(){
      this.$parent.changeMode();
    },
    changeMode2() {
      const mode = this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_VIDEO
          ? this.duerRtcSdk.CallMode.AUDIO_ONLY
          : this.duerRtcSdk.CallMode.AUDIO_VIDEO;
      console.log(mode, this.callInfo.callMode);
      if (mode == this.duerRtcSdk.CallMode.AUDIO_VIDEO) {
        $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
        $('.out-call-mode-txt').text('语音通话');
        $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
        $('.v-mode').text('语音通话');
        $('.audio-tip-wrap').hide();
      } else if (mode == this.duerRtcSdk.CallMode.AUDIO_ONLY) {
        $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
        $('.out-call-mode-txt').text('视频通话');
        $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
        $('.v-mode').text('视频通话');
        $('.audio-tip-wrap').show();
      }
      this.duerRtc.changeCallMode(mode);
      this.callInfo.callMode = mode;
    },
    // 静音状态切换
    changeMute(){
      this.$parent.changeMute();
    },
    changeMute2() {
      if (this.callInfo.mute) {
        $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png');
        $('.a-mute').text('静音');
      } else {
        $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png');
        $('.a-mute').text('已静音');
      }
      this.callInfo.mute = !this.callInfo.mute;
      this.duerRtc.muteAudio(this.callInfo.mute);
    },
    // 挂断通话
    dropCall() {
      this.$parent.dropCall();
    },
    dropCall2() {
      this.duerRtc.dropCall('DROP_CALL_USER_REASON');
    },



    // 设置音视频
    setLayouts(layouts) {
      if (!layouts) {
        return;
      }

      const audioLocal = document.getElementById('audio-local');
      const videoLocal = document.getElementById('video-local');
      const audioPeer = document.getElementById('audio-peer');
      const videoPeer = document.getElementById('video-peer');
      const [layoutLocal, layoutPeer] = layouts;
      if (layoutLocal.videoTrack) {
        $('#video-local').show();
        $('.local-view .audio-tip-wrap').hide();
        const stream = new MediaStream;
        stream.addTrack(layoutLocal.videoTrack);
        videoLocal.srcObject = stream;
      }
      else {
        $('#video-local').hide();
        $('.local-view .audio-tip-wrap').show();
      }
      if (layoutLocal.audioTrack && !layoutLocal.isLocal) {
        const stream = new MediaStream;
        stream.addTrack(layoutLocal.audioTrack);
        audioLocal.srcObject = stream;
      }
      if (layoutPeer.videoTrack) {
        $('#video-peer').show();
        $('.peer-view .audio-tip-wrap').hide();
        const stream = new MediaStream;
        stream.addTrack(layoutPeer.videoTrack);
        videoPeer.srcObject = stream;
      }
      else {
        $('#video-peer').hide();
        $('.peer-view .audio-tip-wrap').show();
      }
      if (layoutPeer.audioTrack) {
        const stream = new MediaStream;
        stream.addTrack(layoutPeer.audioTrack);
        audioPeer.srcObject = stream;
      }

    },
    // 视频大小窗口切换事件
    changeView() {
      $('.peer-view').click(_ => {
        const cList = $('.peer-view').attr('class');
        if (~cList.indexOf('sub-view')) {
          $('.peer-view').attr('class', 'peer-view main-view');
          $('.local-view').attr('class', 'local-view sub-view');
        }
      });
      $('.local-view').click(_ => {
        const cList = $('.local-view').attr('class');
        if (~cList.indexOf('sub-view')) {
          $('.local-view').attr('class', 'local-view main-view');
          $('.peer-view').attr('class', 'peer-view sub-view');
        }
      });
    },
    // 去电响铃时界面展示
    ringViewShow() {
      $('#ring-music').get(0).play();
      $('.peer-name').text(this.callInfo.name);
      if (this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_VIDEO) {
        // 当前为视频通话
        $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
        $('.out-call-mode-txt').text('语音通话');
      } else if (this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_ONLY) {
        // 当前为音频通话
        $('.out-call-mode img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
        $('.out-call-mode-txt').text('视频通话');
      }
      $('#outing-call-view').show();
    },
    // 收到来电
    incomingViewShow() {
      $('#incoming-call-dialog').modal('show');
      $('#ring-music').get(0).play();
    },
    // 空闲状态
    freeCallView() {
      $('#outing-call-view').hide();
      $('#call-view').hide();
      $('#incoming-call-dialog').modal('hide');
      $('#ring-music').get(0).pause();
      Object.assign(this.callInfo, {
        mute: false
      });
    },
    // 通话正常接听
    callViewShow() {
      $('#ring-music').get(0).pause();
      $('#incoming-call-dialog').modal('hide');
      $('#outing-call-view').hide();
      if (this.callInfo.mute) {
        // 已静音
        $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279209/quite.png');
        $('.a-mute').text('已静音');
      } else {
        $('.mute-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515279806/quite0.png');
        $('.a-mute').text('静音');
      }
      if (this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_VIDEO) {
        // 当前为视频通话
        $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661515364706/audio000.png');
        $('.v-mode').text('语音通话');
        $('.audio-tip-wrap').hide();
      } else if (this.callInfo.callMode == this.duerRtcSdk.CallMode.AUDIO_ONLY) {
        // 当前为音频通话
        $('.mode-change-btn img').attr('src', 'https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661828922567/videoCall0.png');
        $('.v-mode').text('视频通话');
        $('.audio-tip-wrap').show();
      }
      $('#call-view').show();
    },
    // 呼叫超时
    callTimeout() {
      $('#outing-call-view').hide();
      $('#message-alert').show();
    },
    // 获取浏览器权限，根据实际情况调用，只限于用户没有做过授权
    getDevice() {
      navigator.getUserMedia = navigator.getUserMedia
          || navigator.webkitGetUserMedia
          || navigator.mozGetUserMedia
          || navigator.msGetUserMedia;
      if (navigator.getUserMedia) {
        navigator.getUserMedia({video: true}, function onSuccess(stream) {
          console.log('摄像头开启成功');
        }, function onError(error) {
          alert("摄像头错误：", error);
        });
        navigator.getUserMedia({audio:true}, function onSuccess(stream) {
          console.log('麦克风开启成功');
        }, function onError(error) {
          alert("麦克风错误：", error);
        });
      }
      else {
        alert('暂不支持');
      }
    },

    // 定时获取摄像头麦克风权限，根据业务实际情况调用
    // 用于定位音视频是否因为权限问题不显示
    // setInterval(_ => {
    //     getDevice();
    // }, 10000);









    toggleModalAdd: function () {
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },


    closeSBJData(){
      this.sBJDataShow =!this.sBJDataShow;
    },
    getData(index,row){
      this.$refs.SBJData.init(row.userCode);
      this.sBJDataShow =!this.sBJDataShow;
    },



    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceXDu/PageByGovCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode:getGovernmentCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          imei: this.imei,
          userCode: this.userCode,
        },
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceXDu/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            deviceXDuCode: row.deviceXDuCode,
          },
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        //this.$message({type: "info", message: "已取消解绑",});
      });
    },




  },
};
</script>

<style scoped>
/*@import 'https://apps.bdimg.com/libs/bootstrap/3.2.0/css/bootstrap.min.css';*/
@import  '../../../../../src/css/boots.css';

</style>



<style>
body {
  background-color: #141e30;
}
#login-form, #device-form {
  width: 500px;
  margin: 20px auto 20px;
}
.usr-info {
  text-align: center;
}
.usr-pho {
  margin-top: 35px;
  width: 120px;
  height: 120px;
}
.usr-name {
  margin-top: 10px;
  font-weight: 500;
  font-size: 30px;
  line-height: 42px;
  color: #1A1A1A;
}
.incoming-call-tip {
  font-size: 16px;
  line-height: 22px;
  color: #666666;
}
.op-btns {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.op-btns img {
  width: 80px;
  height: 80px;
  margin: 16px 40px;
  cursor: pointer;
}
.op-txt {
  line-height: 20px;
  text-align: center;
}
#outing-call-view, #call-view {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10052;
  background: #3c3667;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
#outing-call-view .op-btns {
  margin-top: 50px;
}
.peer-pho {
  width: 104px;
  height: 104px;
  margin-top: 50px;
}
.peer-name {
  font-size: 60px;
  line-height: 86px;
}
.outing-call-tip {
  font-size: 42px;
  line-height: 60px;
  color: rgba(225, 225, 225, .5);
}
#call-view .op-btns {
  position: absolute;
  bottom: 50px;
}
.main-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
}
.main-view video {
  width: 100%;
  object-fit: fill;
}
.main-view .audio-name {
  margin-top: 100px;
  font-size: 62px;
  line-height: 87px;
}
.main-view .audio-call {
  font-size: 36px;
  line-height: 50px;
  color: rgba(225, 225, 225, .5);
  margin-top: 17px;
}
.main-view .audio-tip-wrap {
  position: absolute;
  top: 0;
}
.sub-view {
  width: 320px;
  height: 192px;
  position: absolute;
  left: 48px;
  top: 48px;
  background-image: url('https://dumi-dueros-bj-tob.cdn.bcebos.com/amis/2022-8/1661773897681/audioBg.png');
  background-repeat: no-repeat;
  background-size: 100%;
  color: #fff;
  z-index: 1;
}
.sub-view video {
  width: 320px;
  height: 192px;
  object-fit: fill;
}
.sub-view .audio-tip-wrap {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.sub-view .audio-name {
  font-size: 48px;
  line-height: 67px;
  max-width: 300px;
}
.sub-view .audio-call {
  font-size: 24px;
  line-height: 34px;
  text-align: right;
}
#message-alert {
  position: fixed;
  z-index: 1053;
  width: 300px;
  right: 0;
  top: 10px;
  display: none;
}
.desc-title {
  text-align: center;
  margin-bottom: 20px;
}

</style>


